import { Keuzehulp } from '../keuzehulpen'

const dementie: Keuzehulp = {
  title: 'Dementie',
  basePath: '/wel-of-geen-onderzoek-doen-naar-dementie',
  documentTitle: 'Dementie',
  routes: [
    {
      path: '',
      routeId: 'P8-001',
      nextRouteId: 'P8-002',
      type: 'intro',
      title: 'Voordat u begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/wel-of-geen-onderzoek-naar-dementie',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die u nodig heeft om de keuzehulp in te vullen',
        },
        {
          title: '10 tot 15 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustig plekje',
          description: 'Zodat u zich zonder afleiding kunt concentreren',
        },
        {
          title: 'Bekijk en print uw antwoorden',
          description: 'Aan het einde kunt u uw antwoorden bekijken en printen',
        },
      ],
    },
    {
      path: '/stap-1',
      routeId: 'P8-002',
      nextRouteId: 'P8-003',
      type: 'chapter',
      title: 'Meer weten over geheugenproblemen en dementie',
      subtitle: 'Stap 1',
      description: `<p>Af en toe dingen vergeten betekent niet meteen dat u dementie heeft of krijgt.</p>
        <p>Er is een verschil tussen problemen met het geheugen die horen bij het ouder worden en dementie. In deze stap leest u daar meer over.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/dmt-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/waarom-vergeet-ik-sneller-dingen-als-ik-ouder-word',
      routeId: 'P8-003',
      nextRouteId: 'P8-004',
      type: 'explanation',
      title: 'Waarom vergeet ik sneller dingen als ik ouder word?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Als we ouder worden gaat ons geheugen vaak wat minder goed werken.<br />
          U vergeet dan sneller dingen. Dat is normaal.<br />
          U kunt ook meer moeite krijgen om uw aandacht ergens bij te houden.<br />
          Bijvoorbeeld als u met iemand praat of tijdens het koken.</p>

          <p>Bij maar een klein deel van de mensen met deze klachten is dit het begin van dementie.</p>

          <p>Sneller dingen vergeten komt dus meestal doordat u ouder wordt.<br />
          Uw geheugen kan ook (tijdelijk) minder goed werken door deze dingen:</p>

          <ul>
            <li>te weinig vocht drinken</li>
            <li>als bijwerking van medicijnen die u gebruikt</li>
            <li>alcohol of drugs gebruiken</li>
            <li>stress of een heftige gebeurtenis<br />
            Bijvoorbeeld door geldproblemen. Of als uw partner erg ziek wordt of doodgaat.</li>
            <li>lang somber zijn of een depressie</li>
            <li>een andere ziekte<br />
            Bijvoorbeeld een ontsteking in uw lichaam. Of een ziekte aan uw schildklier.</li>
            <li>een hersenschudding</li>
            <li>als u met medicijnen lang in slaap bent gebracht (narcose)</li>
            <li>de overgang</li>
            <li>te weinig vitamines</li>
          </ul>
          <p>
          Deze dingen kunnen voorbij gaan. Of u kunt er soms voor behandeld worden.<br />
          Dan gaat uw geheugen vaak ook weer beter werken.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/hoe-herken-ik-dementie',
      routeId: 'P8-004',
      nextRouteId: 'P8-005',
      type: 'explanation',
      title: 'Hoe herken ik dementie?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Dementie is meer dan alleen sneller dingen vergeten.<br />
          Bij dementie gaat er iets mis in de hersenen.  Uw hersenen gaan steeds minder goed werken. Hierdoor kunt u steeds minder goed denken.<br />
          Hoe snel dat gaat verschilt per persoon.</p>

          <p>Als u dementie heeft krijgt u steeds meer problemen met de dingen die u elke dag doet. U kunt dat merken aan 1 of meer van deze dingen:</p>

          <ul>
            <li>U onthoudt nieuwe informatie minder goed dan vroeger.</li>
            <li>U weet niet meer wat er kort geleden gebeurd is.</li>
            <li>U weet de weg soms niet meer.</li>
            <li>U weet niet meer welke dag het is of hoe laat het is.</li>
            <li>U vindt het steeds moeilijker om met mensen te praten of iets uit te leggen.</li>
            <li>U kunt minder goed plannen maken.</li>
            <li>U weet niet meer goed hoe dingen moeten.<br />
              Bijvoorbeeld koffie zetten, eten koken en opruimen.</li>
            <li>U voelt zich anders dan vroeger.<br/>
              U bent bijvoorbeeld vaker somber, verdrietig of bang.</li>
            <li>U doet en reageert anders dan vroeger.<br />
              U bent bijvoorbeeld sneller boos of veel minder actief.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/is-er-een-medicijn-tegen-dementie',
      routeId: 'P8-005',
      nextRouteId: 'P8-006',
      type: 'explanation',
      title: 'Is er een medicijn tegen dementie?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Er zijn nog geen goede medicijnen die dementie kunnen verminderen of genezen.</p>

          <p>Er zijn medicijnen die werken op de zenuwen in de hersenen.<br />
          Maar deze medicijnen lijken voor de meeste mensen met dementie niet veel te helpen.<br />
          En de medicijnen hebben wel vaak vervelende bijwerkingen.<br />
          Daarom schrijven artsen deze medicijnen niet vaak voor.<br />
          </p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/zorg-en-hulp-bij-dementie',
      routeId: 'P8-006',
      nextRouteId: 'P8-007',
      type: 'explanation',
      title: 'Zorg en hulp bij dementie',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Hoe snel dementie erger wordt is per persoon verschillend.<br />
          Als u zorg en hulp krijgt, kunt u vaak beter de dingen blijven doen die u elke dag doet.<br />
          Dat kan helpen om bijvoorbeeld langer thuis te blijven wonen.</p>

          <p>Er zijn dingen die u kunt doen om u beter te voelen.<br />
          Bijvoorbeeld sporten en bewegen om langer fit te blijven. Of geheugentraining.</p>

          <p>Een therapeut kan u helpen om alles zo lang mogelijk zelf te blijven doen.<br />
          U oefent samen en bedenkt oplossingen voor problemen.<br />
          Bijvoorbeeld voor het huishouden en het aankleden en uitkleden.</p>

          <p>Als u weet dat u dementie heeft, kan uw huisarts een vaste begeleider voor u zoeken.<br />
          Zo iemand heet een casemanager dementie.<br />
          De casemanager en de huisarts zorgen dat u en uw naasten de hulp krijgen die nodig is.
          </p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2',
      routeId: 'P8-007',
      nextRouteId: 'P8-008',
      type: 'chapter',
      title: 'Onderzoek laten doen naar dementie',
      subtitle: 'Stap 2',
      description: `<p>U twijfelt of u wel of niet wilt laten onderzoeken of u dementie heeft.</p>
        <p style="margin-bottom: 0;">In deze stap leest u:</p>
        <ul class="mt-0">
          <li>hoe het onderzoek naar dementie gaat</li>
          <li>wat er uit het onderzoek kan komen</li>
          <li>wat dat voor u en uw naasten kan betekenen</li>
        </ul>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/dmt-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/hoe-gaat-het-onderzoek',
      routeId: 'P8-008',
      nextRouteId: 'P8-009',
      type: 'explanation',
      title: 'Hoe gaat het onderzoek?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2>Onderzoek door de huisarts</h2>
          <p>Onderzoek naar dementie begint altijd bij de huisarts.</p>
          <p>Uw huisarts kan onderzoeken of u problemen heeft met uw geheugen.<br />
          En of die problemen kunnen komen door dementie.</p>
          <p class="mb-3">Vaak weet de huisarts na het onderzoek of u dementie heeft of niet.</p>

          <h2>Wat kunt u verwachten?</h2>
          <p>Het onderzoek bij de huisarts bestaat meestal uit deze dingen:</p>
          <ul>
            <li>een paar gesprekken met u</li>
            <li>onderzoek van uw lichaam<br />
              Dit is om te weten hoe u beweegt en of u goed hoort en ziet.</li>
            <li>een gesprek met een naaste zonder u erbij <br />
              Bijvoorbeeld met uw partner of uw kind.</li>
            <li>een geheugentest<br />
              Dit is een test met vragen en opdrachten.<br />
              Er zijn speciale geheugentesten voor als u niet zo goed Nederlands kunt.</li>
            <li>soms bloedonderzoek<br />
              Alleen als de huisarts denkt dat u (ook) iets anders zou kunnen hebben.<br />
              Zoals een ontsteking in uw lichaam. Of een ziekte van de schildklier.</li>
          </ul>
          <p class="mb-3">Soms doet de praktijkondersteuner van de huisarts het onderzoek.<br />
          Het onderzoek kan ook bij u thuis gedaan worden als u dat fijner vindt.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/hoe-gaat-het-onderzoek-2',
      routeId: 'P8-009',
      nextRouteId: 'P8-010',
      type: 'explanation',
      title: 'Hoe gaat het onderzoek?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2>Onderzoek door een specialist</h2>
          <p class="mb-3">Soms is na het onderzoek bij de huisarts niet duidelijk of uw geheugenproblemen komen door dementie of door iets anders.<br />
          De huisarts kan u dan doorsturen naar een specialist die veel weet over het geheugen.<br />
          Dit gebeurt alleen als u dit zelf ook wilt.</p>

          <h2>Wat kunt u verwachten?</h2>
          <p>Vaak gaat u voor verder onderzoek naar het ziekenhuis. Soms is daar in het ziekenhuis een speciale afdeling voor: de geheugenpoli.<br />
          De specialist die u daar ziet kan een neuroloog, geriater of psychiater zijn.</p>

          <p>De huisarts kan u ook doorsturen naar een specialist ouderengeneeskunde. Die komt vaak bij u thuis.</p>

          <p>De specialist praat met u en doet vaak een korte geheugentest.<br />
          Daarna kunt u nog 1 of meer van deze onderzoeken krijgen:</p>

          <ul>
            <li>een uitgebreid onderzoek van uw geheugen (vragen en testen) door een psycholoog</li>
            <li>een uitgebreid bloedonderzoek</li>
            <li>een scan/foto van uw hersenen (CT-scan of MRI)</li>
            <li>soms een onderzoek van uw hersenvocht (ruggenprik)</li>
          </ul>

          <p>Vaak krijgt u alle onderzoeken op 1 dag. Dat kan erg druk en vermoeiend zijn.</p>

          <p>Vaak weet de specialist na de onderzoeken of uw geheugenproblemen komen door dementie. Maar soms weet de specialist dat ook nog steeds niet zeker.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/wat-kan-er-uit-het-onderzoek-naar-dementie-komen',
      routeId: 'P8-010',
      nextRouteId: 'P8-011',
      type: 'explanation',
      title: 'Wat kan er uit het onderzoek naar dementie komen?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2>Geen dementie</h2>
          <p>Het onderzoek laat zien dat u geen dementie heeft.<br />
          Soms weet u dat al na het onderzoek bij de huisarts.<br />
          Soms weet u dat pas na verder onderzoek door een specialist.</p>

          <h3 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat kan dit betekenen voor u?</h3>
          <ul class="list-outside mb-3">
            <li>Vaak geeft het veel rust als u zeker weet dat u geen dementie heeft.</li>
            <li>Als u toch sneller dingen vergeet komt dat meestal gewoon door het ouder worden.</li>
            <li>Soms komt uit het onderzoek dat er een andere oorzaak is voor uw klachten waar een behandeling voor is. Uw klachten kunnen dan weer overgaan.<br />
            Bijvoorbeeld bij een depressie, lange tijd stress, een burn-out of een ontsteking in uw lichaam waarvan u in de war bent.</li>
            <li>U kunt het onderzoek altijd op een later moment nog eens laten doen.<br />
            Bijvoorbeeld als uw klachten erger worden. Of als u zich meer zorgen maakt.</li>
          </ul>

          <h2>Wel dementie</h2>
          <p>Het onderzoek laat zien dat u dementie heeft.<br />
          Soms weet u dat al na het onderzoek bij de huisarts.<br />
          Soms weet u dat pas na verder onderzoek door een specialist.</p>

          <h3 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat kan dit betekenen voor u?</h3>
          <ul class="list-outside mb-3">
            <li>Dit kan een grote schok zijn. Ook al had u het misschien al wel verwacht.</li>
            <li>U moet leren leven met een ziekte waarvoor nog geen goede behandeling is.</li>
            <li>U kunt daar erg verdrietig, boos of angstig door zijn.</li>
            <li>Soms gaan mensen anders met u om als ze weten dat u dementie heeft.</li>
            <li>U kunt nu hulp krijgen om met de ziekte om te gaan, zoals een vaste begeleider.</li>
            <li>Uw naasten begrijpen nu wat er met u aan de hand is. Ze kunnen u beter steunen.</li>
            <li>Als u dat wilt kunt u in contact komen met mensen die ook dementie hebben.</li>
            <li>U kunt met anderen uw zorgen bespreken en plannen maken voor de toekomst.</li>
            <li>U kunt op tijd nadenken over geldzaken en dit goed regelen.</li>
            <li>Als u auto rijdt: U moet een rijtest doen bij het Centraal Bureau Rijvaardigheidsbewijzen (CBR).</li>
            <li class="no-bullet">Als de rijtest goed is, kunt u met dementie blijven autorijden.</li>
          </ul>

          <h2>Twijfel over dementie</h2>
          <p>Het onderzoek bij de huisarts of specialist laat zien dat er problemen zijn met uw geheugen.<br />
          Maar het is onzeker of dat door dementie komt.</p>

          <h3 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat kan dit betekenen voor u?</h3>
          <ul class="list-outside mb-3">
            <li>U weet niet zeker of u dementie heeft of gaat krijgen.</li>
            <li>Soms kan een specialist na verder onderzoek wel iets zeggen over de kans die u heeft om later dementie te krijgen. Die kans kan klein of groot zijn. Maar ook dan weet u nog steeds niet zeker of u dementie gaat krijgen of niet.</li>
            <li>U kunt daardoor onrustig blijven. Ook kunt u bang worden voor de toekomst.</li>
            <li>U kunt het onderzoek altijd op een later moment nog eens laten doen. Bijvoorbeeld als uw klachten erger worden.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3',
      routeId: 'P8-011',
      nextRouteId: 'P8-012',
      type: 'chapter',
      title: 'Voordelen en nadelen van onderzoek naar dementie',
      subtitle: 'Stap 3',
      description: `In deze stap zetten we de belangrijkste voordelen en nadelen van het laten doen van onderzoek naar dementie op een rij.`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/dmt-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/voordelen-en-nadelen-van-onderzoek-naar-dementie',
      routeId: 'P8-012',
      nextRouteId: 'P8-013',
      type: 'explanation',
      title: 'Voordelen en nadelen van onderzoek naar dementie',
      description: `
        <table class="table-layout-fixed">
          <thead>
            <tr>
              <th></th>
              <th>Wel onderzoek</th>
              <th>Geen onderzoek</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat is het?</th>
              <td>U gaat naar de huisarts voor het onderzoek.<br/><br/>Soms gaat u daarna ook naar een specialist voor verder onderzoek.</td>
              <td>U laat nu geen onderzoek doen naar dementie.<br/><br/>U kunt later ook nog kiezen voor onderzoek. Bijvoorbeeld bij meer klachten. Of als u zich meer zorgen maakt.</td>
            </tr>
            <tr>
              <th>Wat kan ik verwachten?</th>
              <td>De kans is groot dat u na de onderzoeken weet of u dementie heeft of dat uw klachten door iets anders komen.
              <br/><br/>Er is een kleine kans dat u na het onderzoek nog steeds niet zeker weet of u dementie heeft. </td>
              <td>U weet niet zeker of uw klachten komen door dementie of door iets anders.</td>
            </tr>
            <tr>
              <th>Voordelen</th>
              <td>Als uit het onderzoek komt dat u geen dementie heeft kan dat u en uw naasten geruststellen.<br/><br/>Soms komt er uit het onderzoek een oorzaak van uw klachten die te behandelen is. Bijvoorbeeld een depressie of een bijwerking van medicijnen. Uw klachten kunnen dan weer overgaan.
                <br/><br/>Als u door het onderzoek weet dat u dementie heeft, kunt u de dingen nog regelen die belangrijk voor u zijn. Bijvoorbeeld uw geldzaken en uw wensen voor later.
                <br/><br/>Als u na het onderzoek weet dat u dementie heeft, kunt u een vaste begeleider krijgen. Deze casemanager dementie kan u en uw naasten helpen om zorg en hulp te krijgen. U kunt dan vaak langer de dingen blijven doen die u elke dag doet.</td>
              <td>U hoeft niet naar de huisarts of naar het ziekenhuis voor een onderzoek.<br/><br/>Zolang u weinig klachten heeft kunt u gewoon doorleven zoals u nu doet.</td>
            </tr>
            <tr>
              <th>Nadelen</th>
              <td>Uit het onderzoek kan komen dat u dementie heeft:
                <ul class="list-outside">
                  <li>u moet dan leren omgaan met een ziekte die niet kan genezen en steeds erger wordt</li>
                  <li>dat geeft vaak veel verdriet en angst voor de toekomst</li>
                  <li>mensen in uw omgeving gaan soms anders met u om als ze weten dat u dementie heeft</li>
                </ul>
                <br/>Soms is na het onderzoek nog steeds niet duidelijk of u dementie heeft. Uw zorgen kunnen dan blijven.
              </td>
              <td>U weet niet waardoor uw geheugenproblemen komen. De zorgen daarover kunnen blijven. Ook bij uw naasten.</td>
            </tr>
          </tbody>
        </table>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-4',
      routeId: 'P8-013',
      nextRouteId: 'P8-014',
      type: 'chapter',
      title: 'Wat past het beste bij u?',
      subtitle: 'Stap 4',
      description: `<p>U maakt zelf de keuze om wel of geen onderzoek te laten doen naar dementie. U kunt ook kiezen om er nog mee wachten.</p>
        <p>U krijgt nu zinnen te zien. U kunt aangeven welke zin op dit moment het beste bij u past.  Dat kan u helpen bij het maken van een keuze.</p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/dmt-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P8-014',
      nextRouteId: 'P8-015',
      subtitle: 'Maak een keuze',
      title: 'Wat past er beter bij u?',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik wil zo vroeg mogelijk de oorzaak van mijn klachten weten.' },
        { title: 'Bij weinig klachten wil ik (nog) niet weten of ik dementie heb of ga krijgen.' },
      ],
    },
    {
      path: '/stap-4/vraag-2',
      routeId: 'P8-015',
      nextRouteId: 'P8-016',
      subtitle: 'Maak een keuze',
      title: 'Wat past er beter bij u?',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik wil weten of ik dementie heb zodat ik op tijd zorg en hulp kan krijgen.' },
        {
          title:
            'Ik wil (nog) niet weten of ik dementie heb omdat dat teveel spanning en onrust geeft.',
        },
      ],
    },
    {
      path: '/print-overview',
      routeId: 'P8-016',
      nextRouteId: 'end',
      type: 'end',
      header: {
        description: `
          <p>We hebben uw antwoorden op een rijtje gezet.<br/>
            De antwoorden kunnen u helpen om te kiezen voor wel of geen onderzoek. En u kunt ze ook gebruiken in een gesprek met de mensen om u heen.
          </p>

          <p>Wilt u onderzoek laten doen naar dementie?<br/>
          Maak dan een afspraak met uw huisarts.</p>

          <p> Wilt u geen onderzoek laten doen naar dementie?<br/>
          Dan hoeft u nu niks te doen. U kunt altijd op een later moment nog onderzoek laten doen.<br/>
          Bijvoorbeeld als u meer klachten krijgt. Of als u zich meer zorgen gaat maken.</p>

          <p>Twijfelt u nog over onderzoek naar dementie?</br>
          Het kan helpen om over uw twijfels te praten met de mensen om u heen. U kunt de keuzehulp en uw antwoorden gebruiken voor dat gesprek. U kunt ook een afspraak maken met uw huisarts om gewoon eens over uw twijfels te praten, zonder dat iets moet.</p>
        `,
      },
    },
  ],
}

export default dementie
